export default "__VITE_ASSET__Dvk_wg1A__"